/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { ReactElement } from "react"
import { Modal, ModalHeader, ModalBody } from "@streamlit/lib"
import { CloseSource } from "baseui/modal/types"

interface IDeployModalProps {
  children: React.ReactNode
  onClose: (a: { closeSource?: CloseSource }) => unknown
}

function DeployModal(
  props: React.PropsWithChildren<IDeployModalProps>
): ReactElement {
  const { children, onClose } = props
  return (
    <Modal
      isOpen={true}
      closeable={true}
      onClose={onClose}
      overrides={{
        Dialog: {
          style: {
            width: "860px",
          },
        },
      }}
    >
      <ModalHeader>Deploy this app</ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  )
}

export default DeployModal
